import type { InterfaceNamespaceProperties } from '@unifyapps/defs/types/namespace';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import set from 'lodash/set';
import { create } from 'mutative';

interface Params {
  translations: InterfaceNamespaceProperties['translations'] | undefined;
  data: Record<string, unknown> | undefined;
}

export const adaptDataWithTranslations = ({ translations, data }: Params) => {
  if (isEmpty(translations) || isEmpty(data)) {
    return data;
  }

  return create(data, (draftData) => {
    for (const key of Object.keys(translations)) {
      if (has(draftData, key)) {
        set(draftData, key, translations[key].value);
      }
    }
  });
};
